import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Dialog, TextField, IconButton, DialogTitle, DialogContent, FormControl, MenuItem, Select, Snackbar, Alert, AlertTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import ThemeContextProvider from '../../providers/ThemeProvider';
import Loading from '../../components/Loading';
import Image from '../../components/Image';
import { useChangeOrganizationId } from '../../providers/OrganizationProvider'
import { useTheme } from '../../hooks/useTheme';

import neworganisationImage from '../../assetss/organisation.png'; 
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import axiosInstance from '../../utilities/axios';
import axios from 'axios';

const plans = {
  "Free Plan": "Free plan is great for individuals looking to organize their tasks with unlimited boards, views, and basic collaboration tools.",
  "Standard Plan": "Standard plan is ideal for small teams managing projects with advanced views, templates, and extended activity logs.",
  "Team Plan": "Team plan is built for growing companies that need robust privacy, security, and customization features.",
  "Platinum Plan": "Platinum plan is the ultimate productivity suite for high-performing teams needing seamless communication, tracking, and project oversight.",
};

const Neworganisation = () => {
    const navigate = useNavigate();
    const [organizationName, setOrganizationName] = useState('');
    const [openBusiness, setOpenBusiness] = useState(false);
    const [portalName, setPortalName] = useState("projects.clikkle.com/");
    const [selectedPlan, setSelectedPlan] = useState('Standard Plan');
    const [avatarPreview, setAvatarPreview] = useState(null); // Preview for uploaded image
    const [isPopupOpen, setIsPopupOpen] = useState(true); // Popup state
    const [organizationEmail, setOrganizationEmail] = useState('');
    const [websiteURL, setWebsiteURL] = useState('');
    const [errors, setErrors] = useState({ name: '', email: '', url: '' });
    const [isLoading, setIsLoading] = useState(false); // New loading state
    const [flag, setFlag] = useState(true);
    const [value, setValue] = useState('');
    const [sizeValue, setSizeValue] = useState('');
    const platformUser = useAuthUser();
    const [showMessage, setShowMessage] = useState({
        show: true,
        message: "",
        severity: "",
    });

    //  // console.log(platformUser);


    const changeOrganizationId = useChangeOrganizationId()

    // Helper to check if the required fields are filled
    // const isNextButtonEnabled = organizationName.trim() !== '';

    const theme = useTheme();
    const mode = theme?.mode

    const handlePortalChange = (event) => {
        setPortalName(event.target.value);
    };
    const handleNameChange = (event) => {
        const name = event.target.value;
        setOrganizationName(name);
        setPortalName(`projects.clikkle.com/${name.toLowerCase().replace(/\s+/g, '')}`);
    };

    // Validate email format (must end with @gmail.com)
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setOrganizationEmail(value);
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

        if (!isValidEmail) {
            setFlag(false);
        } else {
            setFlag(true);
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            email: isValidEmail ? null : 'Invalid email format',
        }));
    };

    // Validate URL format (must end with .com)
    const handleURLChange = (e) => {
        const value = e.target.value;
        setWebsiteURL(value);

        const isValidURL = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-]*)*$/i.test(value);
        if (!isValidURL) {
            setFlag(false);
        } else {
            setFlag(true);
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            url: isValidURL ? null : 'Invalid URL format',
        }));
    };

    // Handle file selection and preview
    const handleFileChange = (e) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        const file = files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setAvatarPreview(reader.result); // Preview the uploaded image
            };
            reader.readAsDataURL(file);
        }
    };

    const handleClose = () => {
        setShowMessage({ show: false, message: " ", severity: "" });
    };

    // Function to handle organization creation
    //  // console.log(platformUser._id);
    const handleCreateOrganisation = async () => {
        
        try {
        const userId = JSON.parse(localStorage.getItem("user"));
        const formData = new FormData();
        formData.append("imageUrl", avatarPreview || 'https://cdn.clikkle.com/images/clikkle/logo/2025/clikkle.png');
        formData.append("ownerId", userId._id);
        formData.append("userId", platformUser._id);
        formData.append("name", organizationName);
        formData.append("email", organizationEmail);
        formData.append("website", websiteURL);
        formData.append("portalName", portalName);
        formData.append("plan", selectedPlan);
        formData.append("industry", value);
        formData.append("organizationSize", sizeValue);
        formData.append("ownerEmail", userId.recoveryEmail);

        const response = await axiosInstance.post(`/api/v2/organizations`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        const data = response.data;

        // Check if organization is returned
        if (data.organization?._id) {
                axios.put(
                  `https://api.files.clikkle.com:4500/api/fs/${response.data.organization.folderId}`,
                  {
                    id: response.data.organization.folderId,
                    updates: { color: "#48a1d9" },
                    userId: userId._id,
                  }
                );
            setShowMessage({
                show: true,
                message: data.message || "Organization created successfully",
                severity: "success",
            });

            changeOrganizationId(data.organization._id);
            navigate('/listOrganization');
        } else {
            setShowMessage({
                show: true,
                message: "Something went wrong while creating the organization.",
                severity: "error",
            });
        }

    } catch (e) {
         // console.log("organization method created:", e);

        setShowMessage({
            show: true,
            message: e?.response?.data?.message || e.message || "An error occurred.",
            severity: "error",
        });
    } finally {
        setIsLoading(false);
    }
};


    if (isLoading) {
        return <Loading message="Please wait, logging you in..." />;
    }

    return (
        <ThemeContextProvider>
            <Box>
                <Snackbar
                    open={showMessage.show}
                    autoHideDuration={4000}
                    onClose={handleClose}
                >
                    <Alert
                        severity={showMessage.severity}
                        variant="filled"
                        sx={{ width: "100%" }}
                        anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    >
                        <AlertTitle> {showMessage.severity}</AlertTitle>
                        {showMessage.message}
                    </Alert>
                </Snackbar>
                <Box
                    sx={{
                        backgroundColor: 'background.main',
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: '90px',
                        height: '100vh',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '34px',
                            fontFamily: 'sans-serif',
                            marginLeft: '78px',
                            marginTop: "-22px",
                            '@media(max-width:600px)': {
                                width: '330px',
                                fontSize: '26px',
                                textAlign: 'center',
                                marginLeft: "22px",
                                marginBottom: '22px',
                            },
                        }}
                    >
                        Create an Organization to track the status of your projects.
                    </Typography>
                    <Typography
                        sx={{

                            color: 'gray',
                            marginTop: '12px',
                            marginLeft: '78px',
                            fontFamily: 'sans-serif',
                            '@media(max-width:600px)': {
                                width: '322px',
                                fontSize: '12px',
                                textAlign: 'center',
                                marginLeft: "37px",
                                marginTop: '-13px',
                            },
                        }}
                    >
                        Project organization refers to the style of coordination, communication, and management
                        a team uses throughout a project’s lifecycle.
                    </Typography>

                    <Box sx={{ textAlign: 'center', marginTop: '42px' }}>
                        <Image
                            sx={{
                                height: '370px', // Reduce the height
                                width: 'auto',    // Maintain aspect ratio
                                maxWidth: '100%', // Ensure it doesn’t overflow the parent box
                                '@media(max-width:600px)': {
                                    height: '220px',
                                }
                            }}
                            src={neworganisationImage}
                        />
                    </Box>


                    {/* Popup Dialog */}
                    <Dialog
                        open={isPopupOpen}
                        onClose={() => setIsPopupOpen(false)}
                        aria-labelledby="An organization popup dialog"
                        aria-describedby="An organization popup dialog"
                        // style={{ backgroundColor: 'white' }}
                        PaperProps={{
                            sx: {
                                borderRadius: '10px',
                                // p: { md: 3, xs: 2 },
                                width: { lg: "730px", xs: "95%", md: "80%" },
                                margin: 0,
                                minHeight: { lg: 'fit-content' },
                                background: mode === 'dark' ? 'rgb(23, 23, 23)' : "white",
                            },
                        }}
                    >
                        <DialogTitle id="alert-dialog-title" sx={{ paddingBottom: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Hello, <span className="font-bold"> {platformUser?.firstName?.charAt(0).toUpperCase() + platformUser?.firstName?.slice(1)}!</span>👋 </Typography>
                                <IconButton sx={{ padding: 0 }} onClick={() => navigate('/listOrganization', { unstable_viewTransition: true })}>
                                    <CloseIcon sx={{ color: ' rgb(204,204,204)' }} />
                                </IconButton>
                            </Box>
                            <Typography sx={{ fontWeight: 600, fontSize: 14, fontFamily: 'sans-serif', }}>Welcome to Clickle Projects!</Typography>
                        </DialogTitle>

                        <DialogContent>
{/*                             
                            <Box sx={{ marginBottom: '10px' }}>
                                <Box sx={{ fontWeight: 600, fontSize: 12, paddingTop: '5px' }}>
                                    Start your <Box sx={{ display: 'inline', color: '#0080FF' }}>{selectedPlan === 'Free Plan' ? 'Forever Free Plan' : "14-Days Free Trial"}</Box> of our{' '}
                                    <Box
                                        onClick={() => setOpenBusiness(!openBusiness)}
                                        style={{ backgroundColor: mode === 'dark' ? 'rgb(18, 31, 43)' : "#e5f2ff" }}
                                        sx={{ display: 'inline', padding: '6px', borderRadius: '5px', cursor: 'pointer', position: 'relative' }}
                                    >
                                        {selectedPlan}
                                        {openBusiness && (
                                            <Box
                                                onMouseEnter={() => setOpenBusiness(true)}
                                                onMouseLeave={() => setOpenBusiness(false)}
                                                style={{ backgroundColor: mode === 'dark' ? '#1c1c1c' : "#ffff" }}
                                                sx={{ position: 'absolute', zIndex: 40, width: '200px', padding: '5px', marginTop: '6px', borderRadius: '5px', right: '-5px', boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)' }}
                                            >
                                                <Box sx={{ padding: '2px' }}>
                                                    {Object.keys(plans).map((plan) => (
                                                        <Box
                                                            key={plan}
                                                            onClick={() => {
                                                                setSelectedPlan(plan);
                                                                setOpenBusiness(false);
                                                            }}
                                                            sx={{ cursor: 'pointer', padding: '6px', fontSize: 14 }}
                                                        >
                                                            {plan}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>

                                <Typography
                                    style={{ color: 'rgb(165, 165, 165)' }}
                                    sx={{ fontSize: '14px', margin: '5px 0 6px 0' }}
                                >
                                    {plans[selectedPlan]}
                                </Typography>
                            </Box> */}

                            <Box
                                component="form"
                                noValidate
                                autoComplete="off"
                            >
                                <Box>
                                    <Typography component="label" sx={{ fontWeight: 400, fontSize: '14px', fontFamily: 'sans-serif'}}>
                                        Organization Name
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                        <TextField
                                            fullWidth
                                            margin="none"
                                            variant='outlined'
                                            placeholder="Organization Name"
                                            value={organizationName}
                                            onChange={handleNameChange}
                                            type="text"
                                            error={!!errors.name}
                                            helperText={errors.name}
                                            InputProps={{
                                                style: {
                                                    height: '40px',
                                                    font: 'inherit',
                                                },
                                                sx: {
                                                    marginBottom: '10px',
                                                    '& .MuiInputBase-input::placeholder': {
                                                        fontSize: { md: '14px', xs: '10px' },
                                                    },
                                                }
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box>
                                    <Typography component="label" sx={{ fontWeight: 400, fontSize: '14px', fontFamily: 'sans-serif', }}>
                                        Organization Email
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        margin="none"
                                        placeholder="Enter Email"
                                        variant="outlined"
                                        value={organizationEmail}
                                        onChange={handleEmailChange}
                                        error={!!errors.email}
                                        helperText={errors.email}
                                        InputProps={{
                                            style: {
                                                height: '40px',
                                                font: 'inherit',
                                            },
                                            sx: {
                                                marginBottom: '10px',
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: { md: '14px', xs: '10px' },
                                                },
                                            }
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Typography component="label" sx={{ fontWeight: 500, fontSize: '14px', fontFamily: 'sans-serif', }}>
                                        Organization Website URL
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        margin="none"
                                        placeholder="Enter website URL"
                                        variant="outlined"
                                        value={websiteURL}
                                        onChange={handleURLChange}
                                        error={!!errors.url}
                                        helperText={errors.url}
                                        InputProps={{
                                            style: {
                                                height: '40px',
                                                font: 'inherit',
                                            },
                                            sx: {
                                                marginBottom: '10px',
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: { md: '14px', xs: '10px' },
                                                },
                                            }
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Box
                                sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}
                            >
                                <Typography
                                    style={{ fontWeight: 500, fontSize: '14px', fontFamily: 'sans-serif', }}
                                >
                                    Portal Name
                                </Typography>
                                <TextField
                                    name="portalName"
                                    size="small"
                                    value={portalName}
                                    disabled
                                    variant="outlined"
                                    onChange={handlePortalChange}
                                    fullWidth
                                    className="text-[10px] sm:text-[10px]"
                                    sx={{
                                        fontSize: { md: '10px', xs: '10px' },
                                        '& .MuiInputBase-input': {
                                            fontSize: { md: '14px', xs: '10px' },
                                        },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: { md: '14px', xs: '10px' },
                                        },
                                        marginBottom: '10px'
                                    }}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                <Typography style={{ fontWeight: 500, fontSize: '14px', fontFamily: 'sans-serif', }}>
                                    Industry
                                </Typography>
                                <FormControl fullWidth>
                                    <Select
                                        size="small"
                                        name='industry'
                                        value={value}
                                        onChange={(e) => setValue(e.target.value)}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (selected === '') {
                                                return <span style={{ color: '#aaa' }}>Select</span>;
                                            }
                                            return selected;
                                        }}
                                        sx={{ fontSize: { md: "14px", xs: "10px" }, marginBottom: '10px', }}
                                    >
                                        <MenuItem value="" disabled>
                                            Select
                                        </MenuItem>
                                        <MenuItem value="Education & Training">Education & Training</MenuItem>
                                        <MenuItem value="IT & Software Development">IT & Software Development</MenuItem>
                                        <MenuItem value="Healthcare & Pharmaceuticals">Healthcare & Pharmaceuticals</MenuItem>
                                        <MenuItem value="Real Estate & Property Development">Real Estate & Property Development</MenuItem>
                                        <MenuItem value="Human Resources & Recruitment">Human Resources & Recruitment</MenuItem>
                                        <MenuItem value="Insurance">Insurance</MenuItem>
                                        <MenuItem value="Finance & Banking">Finance & Banking</MenuItem>
                                        <MenuItem value="Marketing & Advertising">Marketing & Advertising</MenuItem>
                                        <MenuItem value="Media & Entertainment">Media & Entertainment</MenuItem>
                                        <MenuItem value="Non-Profit & NGOs">Non-Profit & NGOs</MenuItem>
                                        <MenuItem value="Transportation & Logistics">Transportation & Logistics</MenuItem>
                                        <MenuItem value="Legal Services & Consultancy">Legal Services & Consultancy</MenuItem>
                                        <MenuItem value="Other">Other</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                <Typography style={{ fontWeight: 500, fontSize: '14px', fontFamily: 'sans-serif', }}>Organization Size</Typography>
                                <FormControl fullWidth>
                                    <Select
                                        size="small"
                                        name="organizationSize"
                                        value={sizeValue}
                                        onChange={(e) => setSizeValue(e.target.value)}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (selected === '') {
                                                return <span style={{ color: '#aaa' }}>Select</span>;
                                            }
                                            return selected;
                                        }}
                                        sx={{ fontSize: { md: "14px", xs: "10px" }, marginBottom: '10px' }}
                                    >
                                        <MenuItem value="" disabled>
                                            Select
                                        </MenuItem>
                                        <MenuItem value="0 - 15">0 - 15</MenuItem>
                                        <MenuItem value="15 - 35">15 - 35</MenuItem>
                                        <MenuItem value="35 - 55">35 - 55</MenuItem>
                                        <MenuItem value="55 - 75">55 - 75</MenuItem>
                                        <MenuItem value="75 - 95">75 - 95</MenuItem>
                                        <MenuItem value="95 - 150">95 - 150</MenuItem>
                                        <MenuItem value="150 - 300">150 - 300</MenuItem>
                                        <MenuItem value="300 - 500">300 - 500</MenuItem>
                                        <MenuItem value="500 - 1000">500 - 1000</MenuItem>
                                        <MenuItem value="1000 and above">1000 and above</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box>
                                <Typography component="label" sx={{ fontWeight: 500, fontSize: '14px', fontFamily: 'sans-serif' }}>
                                    Organization Logo
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        sx={{
                                            borderRadius: '50%',
                                            height: '48px', // Set below 20px
                                            width: '48px',  // Set below 20px
                                            minHeight: '18px', // Ensure no default size override
                                            minWidth: '18px',  // Ensure no default size override
                                            borderWidth: '3px',
                                            padding: 0, // Remove padding
                                            margin: 0,  // Remove margin
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            overflow: 'hidden',
                                            color: 'gray',
                                            // borderColor: 'gray',
                                            border: '3px solid rgb(204,204,204)'
                                        }}
                                    >
                                        {avatarPreview ? (
                                            <img
                                                src={avatarPreview}
                                                alt="Uploaded Logo"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '50%',
                                                }}
                                            />
                                        ) : (
                                            <AddIcon sx={{ fontSize: '20px', color: ' rgb(204,204,204)' }} /> // Smaller icon size for smaller button
                                        )}
                                        <input type="file" hidden onChange={handleFileChange} />
                                    </Button>
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    onClick={handleCreateOrganisation}
                                    variant="contained"
                                    sx={{ px: { md: 5, xs: 2, fontWeight: 'bold' }, py: 1, backgroundColor: "#0088FF", fontSize: '12px' }}
                                    disabled={!flag || !organizationEmail || !websiteURL || !avatarPreview}
                                >
                                    Create
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </Box>
            </Box>
        </ThemeContextProvider>
    );
};

export default Neworganisation;